import styled from 'styled-components';
import { BidStatusList, FilterType } from '../FilterData';
import { useEffect, useState } from 'react';
import {
  ApplyButton,
  Bottom,
  ButtonBox,
  ResetButton,
} from './OptionModal.styles';

interface Props {
  onClose: () => void;
  filters: FilterType;
  setFilters: (filters: FilterType) => void;
}

function BidnoOption({ onClose, filters, setFilters }: Props) {
  const [selectedItem, setSelectedItem] = useState(
    BidStatusList.find((item) => item.value === filters.bidno)?.label || '',
  );

  const handleReset = () => {
    setSelectedItem('');
  };

  const handleSubmit = () => {
    const value = BidStatusList.find((item) => item.label === selectedItem);
    setFilters({
      ...filters,
      bidno: value?.value ?? '',
    });
    onClose();
  };

  return (
    <Wrapper>
      <ListBox>
        {BidStatusList.map(({ label }) => (
          <Item key={label} onClick={() => setSelectedItem(label)}>
            <img
              src={`/assets/images/check/${selectedItem.includes(label) ? 'circle-checked-blue' : 'circle-checked-gray'}.svg`}
              alt=""
            />
            {label}
          </Item>
        ))}
      </ListBox>
      <Bottom>
        <ButtonBox>
          <ResetButton onClick={handleReset}>
            <img
              src="/assets/images/icon/reset.svg"
              alt=""
              width={24}
              height={24}
            />
            <span>초기화</span>
          </ResetButton>
          <ApplyButton onClick={handleSubmit}>적용</ApplyButton>
        </ButtonBox>
      </Bottom>
    </Wrapper>
  );
}

export default BidnoOption;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const ListBox = styled.div`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #e1e2e4;
  padding: 24px 16px;
  gap: 8px;
`;

const Item = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 4px;
  padding-bottom: 4px;
  gap: 8px;

  color: #616161;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
`;
